import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const RequestSubmitPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleCancelIcon} open={props.open}>
      <Box className={classes.root}>
        
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>{(props.screen == 'support') ? 'Ticket Created' : 'Data Privacy Request Submitted '}</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
            <Box className={classes.imageContainer}>
                {(props.screen == 'support') && <span className={classes.request}>Your ticket {props?.submitResponse?.supportRequestNumber} was created successfully.</span>}   
                {(props.screen == 'ccpa') && <span  className={classes.request}>Your data privacy request has been submitted successfully under CCPA law.</span> }          
            </Box> 
              {(props.screen == 'support') && <Typography className={classes.paragraph}>Our support team will review your ticket and work diligently to address your concern which may take up to 5 business days.</Typography> }
             {(props.screen == 'ccpa') && props.borrowerEmail && <Typography className={classes.paragraph}>We will review and process it within next 45 days. An email is also sent to you on your registered email address <b>{props.borrowerEmail}</b>. We may reach out to you if we require any additional information.</Typography>}
             {(props.screen == 'ccpa') && !props.borrowerEmail && <Typography className={classes.paragraph}>We will review and process it within next 45 days. We may reach out to you if we require any additional information.</Typography>}
             {(props.screen == 'ccpa') && <Typography className={classes.paragraph}>If you have any questions, please <a href="./HelpLanding?contactus" target="_blank" className={classes.contact}>contact us</a>.</Typography>}
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleCancelIcon}
            >Got it</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
